import InfoCode from './InfoCode'

export default InfoCode